var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { chatBotManager } from "./../../domains/utils/chatBotMananger";
import search from "@domains/utils/search";
import { STREAMING_TYPE } from "@adapters/repositories/stream/IQuoteStreamRepo";
import { StreamingSectionName } from "@adapters/repositories/stream/QuoteStreamRepo";
import { marketStatusMapper } from "@domains/utils/footerStreamUtil";
var FooterPresenter = /** @class */ (function () {
    function FooterPresenter(useCases, useCasesStream, actions) {
        this.useCases = useCases;
        this.useCasesStream = useCasesStream;
        this.actions = actions;
    }
    FooterPresenter.prototype.getMarketStatus = function () {
        var _this = this;
        this.actions.footer.startLoader();
        this.useCases.footer
            .getMarketStatus()
            .then(function (data) {
            _this.actions.footer.stopLoader();
            _this.actions.footer.getMarketStatus(data);
            // const localMappedData = JSON.parse(
            //   localStorage.getItem("marketStatus")
            // );
            // localMappedData &&
            //   localMappedData !== null &&
            _this.actions.footer.getMarketStatusStreaming(marketStatusMapper(data));
            localStorage.setItem("marketStatus", JSON.stringify(marketStatusMapper(data)));
        })
            .catch(function (err) {
            _this.actions.footer.stopLoader();
            var localMappedData = JSON.parse(localStorage.getItem("marketStatus"));
            localMappedData &&
                localMappedData !== null &&
                _this.actions.footer.getMarketStatusStreaming(localMappedData);
        });
    };
    FooterPresenter.prototype.marketStatusStreaming = function (subscribe) {
        var _this = this;
        this.useCasesStream.streamQuote(STREAMING_TYPE.MARKET_STATUS, subscribe, function (mappedData) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.actions.footer.getMarketStatusStreaming(mappedData);
                return [2 /*return*/];
            });
        }); }, [], [], StreamingSectionName.FOOTERSTATUS);
    };
    FooterPresenter.prototype.updateShowMob_Menu = function (showFooter) {
        this.actions.footer.updateShowMob_Menu(showFooter);
    };
    FooterPresenter.prototype.setShowFooterUi = function (showFooterUi) {
        this.actions.footer.setShowFooterUi(showFooterUi);
    };
    FooterPresenter.prototype.getFooterPdfLinks = function () {
        return this.useCases.footer.getFooterPdfLinks();
    };
    FooterPresenter.prototype.showChatBot = function (req) {
        var result = chatBotManager(req.route, req.isSidebar);
        this.actions.footer.updateChatBotState(result);
    };
    FooterPresenter.prototype.hideChatBot = function () {
        this.actions.footer.hideChatBot();
    };
    FooterPresenter.prototype.getExchangeHolidays = function () {
        var _this = this;
        this.actions.staticFooter.exchangeHolidays.hideError();
        this.actions.staticFooter.exchangeHolidays.loader();
        this.useCases.staticFooter.exchangeHolidays.execute({
            onSuccess: function (data) {
                if (data)
                    _this.actions.staticFooter.exchangeHolidays.getExchangeHolidayData(data);
                _this.actions.staticFooter.exchangeHolidays.stopLoader();
            },
            onError: function (error) {
                _this.actions.staticFooter.exchangeHolidays.setError({
                    isOpen: true,
                    error: error,
                });
                _this.actions.staticFooter.exchangeHolidays.stopLoader();
            },
        }, null);
    };
    FooterPresenter.prototype.getCircularUpdates = function (req) {
        var _this = this;
        this.actions.staticFooter.circularUpdate.hideError();
        this.actions.staticFooter.circularUpdate.loader();
        this.useCases.staticFooter.circularUpdate.execute({
            onSuccess: function (data) {
                if (data)
                    _this.actions.staticFooter.circularUpdate.getCircularUpdate(data);
                _this.actions.staticFooter.circularUpdate.stopLoader();
            },
            onError: function (error) {
                _this.actions.staticFooter.circularUpdate.setError({
                    isOpen: true,
                    error: error,
                });
                _this.actions.staticFooter.circularUpdate.stopLoader();
            },
        }, req);
    };
    FooterPresenter.prototype.getlocationUpdates = function () {
        var _this = this;
        this.actions.staticFooter.location.hideError();
        this.actions.staticFooter.location.loader();
        this.useCases.staticFooter.locateus.execute({
            onSuccess: function (data) {
                if (data)
                    _this.actions.staticFooter.location.getlocationData(data);
                _this.actions.staticFooter.location.stopLoader();
            },
            onError: function (error) {
                _this.actions.staticFooter.location.setError({
                    isOpen: true,
                    error: error,
                });
                _this.actions.staticFooter.location.stopLoader();
            },
        }, null);
    };
    FooterPresenter.prototype.getFaqUpdates = function () {
        var _this = this;
        this.actions.staticFooter.faq.hideError();
        this.actions.staticFooter.faq.loader();
        this.useCases.staticFooter.faqlist.execute({
            onSuccess: function (data) {
                if (data)
                    _this.actions.staticFooter.faq.getFaqData(data);
                _this.actions.staticFooter.faq.stopLoader();
            },
            onError: function (error) {
                _this.actions.staticFooter.faq.setError({
                    isOpen: true,
                    error: error,
                });
                _this.actions.staticFooter.faq.stopLoader();
            },
        }, null);
    };
    FooterPresenter.prototype.getSearchedCircularData = function (data, searchData) {
        return search(data, "title", searchData);
    };
    return FooterPresenter;
}());
export default FooterPresenter;
